<template>
  <div class="page-project-baisc relative-position">
    <transition name="slide-fade" mode="out-in">
      <div v-if="!editing">
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary v-mr-xs" />
              <span class="text-bold">项目基本信息</span>
              <div class="v-ml-auto" v-if="[1, 2, 7].includes(data.state) && hasPermission('project:school:basic:edit')">
                <a-button type="indigo" size="small" icon="form" @click="handleEdit">修改</a-button>
              </div>
            </div>
          </div>
          <table class="table table-plain">
            <tbody>
              <tr>
                <th>项目名称</th>
                <td>{{ data.name }}</td>
                <th>项目编号</th>
                <td>{{ data.code }}</td>
              </tr>
              <tr>
                <th>项目实施周期</th>
                <td>
                  {{ data.startDate ? data.startDate.substring(0, 10) : '' }}
                  <template v-if="data.endDate">~ {{ data.endDate.substring(0, 10) }}</template>
                </td>
                <th valign="top">项目协议</th>
                <td>
                  <file-container :img-size="[100, 55]" :files="data.files" :belongId="projectId" fileSign="P01" v-if="data.files"></file-container>
                </td>
              </tr>
              <tr>
                <th>学校名称</th>
                <td colspan="3">{{ extInfo.schoolName }}</td>
              </tr>
              <tr>
                <th>合作单位名称</th>
                <td colspan="3">{{ extInfo.cooperatorName }}</td>
              </tr>
              <tr>
                <th width="180">合作单位联系人姓名</th>
                <td width="40%">{{ extInfo.cooperatorContact }}</td>
                <th width="160">合作单位联系人手机</th>
                <td>{{ extInfo.cooperatorPhone }}</td>
              </tr>
              <tr>
                <th>书籍接收地址</th>
                <td colspan="3">{{ extInfo.bookReceiverAddr }}</td>
              </tr>
              <tr>
                <th>书籍接收人姓名</th>
                <td colspan="3">{{ extInfo.bookReceiverName }}</td>
              </tr>
              <tr>
                <th>书籍接收人手机</th>
                <td colspan="3">{{ extInfo.bookReceiverPhone }}</td>
              </tr>
            </tbody>
          </table>
          <div class="text-left v-mt-xs">
            <span class="hover-line text-indigo text-underline" @click="showLxFormData = true">查看更多信息</span>
          </div>
        </div>

        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">山区学校（协同用户）</span>
              <div class="v-ml-auto" v-if="userList1.length && isProcessable(1)">
                <a-button icon="form" size="small" type="indigo" @click="handelSetUsers(3)" v-if="hasPermission('project:school:user:school')">修改</a-button>
              </div>
            </div>
          </div>
          <div class="v-pa-lg" style="border: 1px solid #eee" v-if="userList1.length == 0">
            <a-empty :image="emptyImage">
              <div slot="description">
                未设置山区学校用户<template v-if="hasPermission('project:school:user:school')">，<span class="text-indigo hover-line" @click="handelSetUsers(3)" v-if="isProcessable(1)">立即设置</span></template>
              </div>
            </a-empty>
          </div>
          <template v-else>
            <table class="table table-plain" :class="{ 'v-mt-sm': index > 0 }" v-for="(item, index) in userList1" :key="item.id">
              <tbody>
                <tr>
                  <th width="180">山区学校用户名</th>
                  <td width="40%">{{ item.realName }}</td>
                  <th width="160">注册手机</th>
                  <td>{{ item.phone }}</td>
                </tr>
                <tr>
                  <th>所在地址</th>
                  <td>{{ item.province }}{{ item.city }}{{ item.district }}{{ item.addr }}</td>
                  <th>联系人</th>
                  <td>{{ item.contactPerson }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>

        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">山区学校合作伙伴（协同用户）</span>
              <div class="v-ml-auto" v-if="userList2.length && isProcessable(1)">
                <a-button icon="form" size="small" type="indigo" @click="handelSetUsers(4)" v-if="hasPermission('project:school:user:copartner')">修改</a-button>
              </div>
            </div>
          </div>
          <div class="v-pa-lg" style="border: 1px solid #eee" v-if="userList2.length == 0">
            <a-empty :image="emptyImage">
              <div slot="description">
                未设置山区学校合作伙伴用户<template v-if="hasPermission('project:school:user:copartner')">，<span class="text-indigo hover-line" @click="handelSetUsers(4)" v-if="isProcessable(1)">立即设置</span></template>
              </div>
            </a-empty>
          </div>
          <template v-else>
            <table class="table table-plain" :class="{ 'v-mt-sm': index > 0 }" v-for="(item, index) in userList2" :key="item.id">
              <tbody>
                <tr>
                  <th width="180">合作伙伴用户名</th>
                  <td width="40%">{{ item.realName }}</td>
                  <th width="160">注册手机</th>
                  <td>{{ item.phone }}</td>
                </tr>
                <tr>
                  <th>所在地址</th>
                  <td>{{ item.province }}{{ item.city }}{{ item.district }}{{ item.addr }}</td>
                  <th>联系人</th>
                  <td>{{ item.contactPerson }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </div>
        <!--
        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">项目管理人员</span>
              <div class="v-ml-auto" v-if="data.state == 7 && isProcessable(1)">
                <a-space :size="6" v-if="memberEditing">
                  <a-button icon="plus" size="small" type="indigo" @click="openMemberForm()">添加管理人员</a-button>
                  <a-button icon="close" size="small" type="default" @click="memberEditing = false">取消</a-button>
                </a-space>
                <a-button icon="form" size="small" type="indigo" @click="memberEditing = true" v-else>修改</a-button>
              </div>
            </div>
          </div>
          <a-table class="list-table" size="small" rowKey="memberId" :pagination="false" :loading="loading" :data-source="data.members" :scroll="{ x: '100%' }">
            <a-table-column title="#" data-index="index" :width="55" align="center">
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column title="人员类型" data-index="memberDuty" :width="120" align="left" />
            <a-table-column title="姓名" data-index="memberName" :width="120" align="left" />
            <a-table-column title="联系电话" data-index="phone" :ellipsis="true" :width="180" align="left" />
            <a-table-column title="职务" data-index="memberPost" :ellipsis="true" align="left" />
            <a-table-column title="工作经验" data-index="experience" :ellipsis="true" align="left" />
            <a-table-column title="操作" data-index="action" :width="60" align="center" v-if="memberEditing">
              <template slot-scope="text, record">
                <a-space class="table-actions" :size="4">
                  <span class="table-action" title="编辑" @click="openMemberForm(record)"><a-icon type="form" /></span>
                  <span class="table-action text-red" title="删除" @click="onRemoveMember(record)"><a-icon type="close" /></span>
                </a-space>
              </template>
            </a-table-column>
          </a-table>
        </div>

        <div class="panel-info-section">
          <div class="panel-info-section-title">
            <div class="flex items-center">
              <a-icon type="caret-right" class="text-primary" />
              <span class="text-bold">对应资金池</span>
              <div class="v-ml-auto" v-if="data.state == 7 && isProcessable(1)">
                <a-button icon="form" size="small" type="indigo" @click="poolModal = true">设置</a-button>
              </div>
            </div>
          </div>
          <a-table class="list-table" size="small" rowKey="id" :pagination="false" :loading="loading" :data-source="pools" :scroll="{ x: '100%' }">
            <a-table-column title="#" data-index="index" :width="55" align="center">
              <template slot-scope="text, record, index">
                {{ index + 1 }}
              </template>
            </a-table-column>
            <a-table-column title="资金池名称" data-index="poolName" align="left" />
            <a-table-column title="资金使用方向" data-index="usage" :width="150" align="left" />
            <a-table-column title="筹款公益平台及支付方式" data-index="phone" :ellipsis="true" align="left">
              <template slot-scope="text, record">
                <div :title="item.fundName" class="ellipsis" v-for="item in record.fundNames" :key="item.id">
                  <a-icon style="width: 18px" type="alipay-circle" class="text-blue" v-if="item.fundType == '0'" /> 
                  <a-icon style="width: 18px" type="wechat" class="text-green" v-else-if="item.fundType == '1'" /> 
                  {{ item.fundName }}
                </div>
                <div :title="item.paymentName" class="ellipsis" v-for="item in record.fundLarges" :key="item.id">
                  <i class="fa fa-cubes text-orange"></i>
                  {{ item.paymentName }}
                </div>
              </template>
            </a-table-column>
          </a-table>
        </div>
        -->
      </div>
      <div class="section-basic-edit" v-else>
        <div class="w1000" style="margin-top: 20px">
          <div class="panel">
            <a-form-model ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 14 }">
              <h3 class="text-center text-primary v-my-md">修改基本信息</h3>
              <div class="panel-body">
                <a-row :gutter="0">
                  <a-col span="24">
                    <a-form-model-item :colon="false" prop="name" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <span slot="label">
                        <i class="required-mark">*</i>
                        项目名称
                      </span>
                      <a-input placeholder="项目名称" v-model="form.name" ref="name" style="width: calc(100% - 40px)" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false" prop="period">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        实施周期
                      </span>
                      <a-range-picker v-model="form.dates" format="YYYY-MM-DD" value-format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onDateRangeChange2" ref="datePicker2" style="width: 220px" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="0">
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        学校名称
                      </span>
                      <a-input v-model="form.schoolName" ref="schoolName" style="width: calc(100% - 40px)" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        合作单位名称
                      </span>
                      <a-input v-model="form.cooperatorName" ref="cooperatorName" style="width: calc(100% - 40px)" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <a-row :gutter="0">
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        合作单位联系人姓名
                      </span>
                      <a-input v-model="form.cooperatorContact" ref="cooperatorContact" style="width: 220px" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        合作单位联系人手机
                      </span>
                      <a-input v-model="form.cooperatorPhone" ref="cooperatorPhone" style="width: calc(100% - 40px)" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="24">
                    <a-form-model-item :colon="false" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        书籍接收地址
                      </span>
                      <a-input v-model="form.bookReceiverAddr" ref="bookReceiverAddr" style="width: calc(100% - 40px)" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        书籍接收人姓名
                      </span>
                      <a-input v-model="form.bookReceiverName" ref="bookReceiverName" style="width: 220px" />
                    </a-form-model-item>
                  </a-col>
                  <a-col span="12">
                    <a-form-model-item :colon="false">
                      <span slot="label">
                        <i class="required-mark" v-if="data.state == 7">*</i>
                        书籍接收人手机
                      </span>
                      <a-input v-model="form.bookReceiverPhone" ref="bookReceiverPhone" style="width: calc(100% - 40px)" />
                    </a-form-model-item>
                  </a-col>
                </a-row>
                <div class="text-center v-mt-md">
                  <a-space :size="12">
                    <a-button type="primary" size="default" icon="check" :loading="saving" @click="confirmSubmit">保存</a-button>
                    <a-button type="default" size="default" icon="close" @click="editing = false">取消</a-button>
                  </a-space>
                </div>
              </div>
            </a-form-model>
          </div>
        </div>
      </div>
    </transition>
    <a-drawer title="详细信息" placement="right" destroy-on-close :closable="false" :width="840" :wrap-style="{ top: '103px' }" :body-style="{ paddingBottom: '120px' }" :visible="showLxFormData" @close="showLxFormData = false">
      <template v-if="extInfo.lxdata && lxFormData.props">
        <a-descriptions bordered layout="horizontal" :column="1" v-if="lxFormData.ptype && ![1, 2, 3].includes(lxFormData.ptype)">
          <a-descriptions-item :label="item.fieldName" v-for="item in lxFormData.props" :key="item.key">
            <div :key="item.key" v-if="item.fieldType == 3 && lxFormData.files && lxFormData.files[item.key]">
              <file-container :img-size="[100, 55]" :files="lxFormData.files[item.key]" :belongId="+lxFormData.formId" fileSign="activity"></file-container>
            </div>
            <template v-else-if="item.fieldType == 9">{{ lxFormData.data[item.key].area.join('') + lxFormData.data[item.key].address }}</template>
            <template v-else>{{ lxFormData.data[item.key] }}</template>
          </a-descriptions-item>
        </a-descriptions>
        <a-descriptions bordered layout="horizontal" :column="1" v-viewer="{ movable: true, transition: false, toolbar: true, url: 'data-original' }" v-else>
          <a-descriptions-item :label="item.label_Name" v-for="item in lxFormData.props" :key="item.label_Id">
            <div v-if="lxFormData.data[item.label_Id]">
              <template v-if="!lxFormData.data[item.label_Id].is_image">{{ lxFormData.data[item.label_Id].value }}</template>
              <div class="lx-form-image" v-else>
                <img class="cursor-pointer" v-lazy="lxFormData.data[item.label_Id].value" :data-original="lxFormData.data[item.label_Id].value" :alt="item.label_Name" />
              </div>
            </div>
          </a-descriptions-item>
        </a-descriptions>
      </template>
    </a-drawer>
    <!-- 成员弹窗 -->
    <a-modal :visible="memberModal" :width="500" @cancel="memberModal = false" @ok="onSaveMember" ok-text="保存" centered :title="memberModalTitle">
      <a-form-model autocomplete="off" :label-col="{ span: 5 }" :wrapper-col="{ span: 17 }">
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            人员类型
          </span>
          <a-select placeholder="选择人员类型" v-model="memberForm.memberDuty" style="width: 100%" ref="memberDuty">
            <a-select-option v-for="item in memberDuties" :key="item.value === void 0 ? item.label : item.value">
              {{ item.label }}
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">
            <i class="required-mark">*</i>
            姓名
          </span>
          <a-input v-model="memberForm.memberName" style="width: 100%" placeholder="联系人姓名" ref="memberName" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">职务</span>
          <a-input v-model="memberForm.memberPost" style="width: 100%" placeholder="职务" ref="memberPost" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">电话</span>
          <a-input v-model="memberForm.phone" style="width: 100%" placeholder="电话/手机号码" ref="phone" />
        </a-form-item>
        <a-form-item :colon="false">
          <span slot="label">工作经验</span>
          <a-textarea v-model="memberForm.experience" placeholder="工作经验" ref="experience" :rows="4" />
        </a-form-item>
      </a-form-model>
    </a-modal>
    <pool-selector :project-id="projectId" v-model="poolModal" :selected="pools.map(d => d.id)" @submit="onPoolSubmit" />
    <user-selector :project="data" :selected="userType == 3 ? userList1.map(d => d.userId) : userList2.map(d => d.userId)" :title="userType == 3 ? '设置山区学校' : '设置山区学校合作伙伴'" :userType="userType" :project-id="projectId" v-model="userModal" @submit="onUserSubmit" />
  </div>
</template>

<script>
import { viewPrj, updatePrj } from '@/api/project/school'
import { saveMember, delMember } from '@/api/project/common'
import { convertLxForm } from '@/utils/data'
const memberForm = {
  id: undefined,
  memberName: '',
  memberDuty: undefined,
  phone: '',
  memberPost: '',
  experience: '',
  memberState: 1,
}
const form = {
  name: '',
  startDate: undefined,
  endDate: undefined,
  schoolName: '',
  cooperatorName: '',
  cooperatorContact: '',
  cooperatorPhone: '',
  bookReceiverAddr: '',
  bookReceiverName: '',
  bookReceiverPhone: '',
  dates: [],
}

export default {
  name: 'ProjectBasic',
  data() {
    return {
      loading: false,
      projectId: +this.$route.query.id,
      data: {},
      extInfo: {},
      pools: [],
      showAllContent: false,
      editing: false,
      form: {},
      saving: false,
      addressList: [],
      memberList: [],
      userList1: [],
      userList2: [],
      poolList: [],
      lxFormData: {},
      showLxFormData: false,
      memberEditing: false,
      memberModalTitle: '',
      memberModal: false,
      memberForm: { ...memberForm },
      poolModal: false,
      userModal: false,
      userRoles: undefined,
      userType: 3,
    }
  },
  computed: {
    memberDuties: vm => vm.$store.state.app.memberDuties,
  },
  watch: {
    $route() {
      this.init()
    },
  },
  methods: {
    init() {
      let { id } = this.$route.query
      if (id) {
        this.projectId = +id
        this.load()
      }
    },
    load() {
      this.loading = true
      viewPrj(this.projectId, true).then(({ data }) => {
        if (data.success) {
          let result = data.result
          let { pools, studyInfo = {}, users = [] } = result
          this.pools = pools || []
          this.data = result
          this.extInfo = studyInfo
          let { lxdata } = studyInfo
          if (lxdata) {
            this.lxFormData = convertLxForm(lxdata)
          }
          this.userList1 = users.filter(d => d.projectUserType == 3)
          this.userList2 = users.filter(d => d.projectUserType == 4)
        }
        this.loading = false
      })
    },
    handelSetUsers(userType) {
      this.userType = userType
      this.$nextTick(() => {
        this.userModal = true
      })
    },
    handleEdit() {
      let {
        startDate,
        endDate,
        studyInfo: { schoolName = '', cooperatorName = '', cooperatorContact = '', cooperatorPhone = '', bookReceiverAddr = '', bookReceiverName = '', bookReceiverPhone = '' },
      } = this.data
      this.form = { ...form, ...this.data, schoolName, cooperatorName, cooperatorContact, cooperatorPhone, bookReceiverAddr, bookReceiverName, bookReceiverPhone, dates: startDate && endDate ? [startDate, endDate] : [] }
      this.editing = true
    },
    onDataRangeChange(date, dateString) {
      let [startDate, endDate] = dateString
      this.form.startDate = startDate
      this.form.endDate = endDate
    },
    confirmSubmit() {
      let { state, name, dates, schoolName, cooperatorName, cooperatorContact, cooperatorPhone, bookReceiverAddr, bookReceiverName, bookReceiverPhone } = this.form
      this.$message.destroy()
      if (name.trim() === '') {
        this.$message.warning('请输入项目名称')
        this.$refs.name.focus()
        return
      }
      if (state == 7) {
        if (dates.length === 0) {
          this.$message.warning('请选择实施周期')
          this.$refs.datePicker2.focus()
          return
        }
        if (schoolName.trim() === '') {
          this.$message.warning('请输入学校名称')
          this.$refs.schoolName.focus()
          return
        }
        if (cooperatorName.trim() === '') {
          this.$message.warning('请输入合作单位名称')
          this.$refs.cooperatorName.focus()
          return
        }
        if (cooperatorContact.trim() === '') {
          this.$message.warning('请输入合作单位联系人姓名')
          this.$refs.cooperatorContact.focus()
          return
        }
        if (cooperatorPhone.trim() === '') {
          this.$message.warning('请输入合作单位联系人手机')
          this.$refs.cooperatorPhone.focus()
          return
        }
        if (bookReceiverAddr.trim() === '') {
          this.$message.warning('请输入书籍接收地址')
          this.$refs.bookReceiverAddr.focus()
          return
        }
        if (bookReceiverName.trim() === '') {
          this.$message.warning('请输入书籍接收人姓名')
          this.$refs.bookReceiverName.focus()
          return
        }
        if (bookReceiverPhone.trim() === '') {
          this.$message.warning('请输入书籍接收人手机')
          this.$refs.bookReceiverPhone.focus()
          return
        }
      }
      this.$confirm({
        title: '确认修改项目？',
        centered: true,
        onOk: () => {
          this.handleSubmit()
        },
      })
    },
    handleSubmit() {
      this.$message.destroy()
      let { id, name, dates, schoolName, cooperatorName, cooperatorContact, cooperatorPhone, bookReceiverAddr, bookReceiverName, bookReceiverPhone, housePopulation, perCapitaArea, perCapitaIncome } = this.form
      let params = {
        id,
        name,
        startDate: dates[0] ? `${dates[0]} 00:00` : undefined,
        endDate: dates[1] ? `${dates[1]} 00:00` : undefined,
        studyInfo: {
          schoolName,
          cooperatorName,
          cooperatorContact,
          cooperatorPhone,
          bookReceiverAddr,
          bookReceiverName,
          bookReceiverPhone,
        },
      }
      this.saving = true
      updatePrj(params)
        .then(({ data }) => {
          if (data.success) {
            this.$message.success('操作成功')
            this.load()
            this.editing = false
            this.$root.$emit('reloadPrj')
          } else {
            this.$message.error(data.msg)
          }
          this.saving = false
        })
        .catch(() => {
          this.saving = false
          this.$message.error('操作失败')
        })
    },
    openMemberForm(record) {
      if (record) {
        this.memberForm = { ...memberForm, ...record }
        this.memberModalTitle = '编辑管理人员'
      } else {
        this.memberModalTitle = '添加管理人员'
        this.memberForm = { ...memberForm, uid: this.$utils.uuid() }
      }
      this.memberModal = true
    },
    onRemoveMember(record) {
      let { memberId } = record
      this.$confirm({
        title: '确认删除？',
        centered: true,
        onOk: () => {
          // 异步关闭
          return new Promise((resolve, reject) => {
            delMember(memberId, this.projectId).then(({ data }) => {
              if (data.success) {
                this.$message.success('操作成功')
                this.memberModal = false
                this.load()
                resolve()
              } else {
                this.$message.warn('操作失败')
                reject()
              }
            })
          }).catch(() => {})
        },
      })
    },
    onSaveMember() {
      let { projectId } = this
      let { memberId, memberName, memberDuty, memberPost, experience, phone } = this.memberForm
      memberName = memberName.trim()
      this.$message.destroy()
      if (!memberDuty) {
        this.$message.warning('请选择人员类型')
        this.$refs.memberDuty.focus()
        return
      }
      if (memberName === '') {
        this.$message.warning('请输入人员姓名')
        this.$refs.memberName.focus()
        return
      }
      let params = {
        memberId,
        memberName,
        memberDuty,
        projectId,
        memberPost: memberPost.trim(),
        experience: experience.trim(),
        phone: phone.trim(),
      }
      saveMember(params).then(({ data }) => {
        if (data.success) {
          this.$message.success('操作成功')
          this.memberModal = false
          this.load()
        } else {
          this.$message.warn('操作失败')
        }
      })
    },
    onPoolSubmit() {
      this.poolModal = false
      this.$root.$emit('reloadPrj')
      this.load()
    },
    onUserSubmit() {
      this.userModal = false
      this.load()
    },
  },
  mounted() {
    this.init()
  },
}
</script>
